import axios from "../../../api/axios";

export const fetchVideos = async () => {
    return axios.get('/video').then(res=> res.data)
}

export const fetchVideoById = async (id) => {
    return axios.get(`/video?id=${id}`).then(res=> res.data)
}
